var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHmCoreLogoGlow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 333,
    height: 391,
    viewBox: "0 0 333 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_f_0_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.145 236.808C176.062 229.444 172.01 222.765 166.402 217.911C160.794 213.061 153.621 210.091 146.234 210.032H146.181H146.121C131.347 210.091 121.084 222.076 123.309 236.808C124.392 244.173 128.384 250.851 133.992 255.705C139.603 260.556 146.776 263.523 154.157 263.582H154.216H154.276C154.853 263.582 155.427 263.582 156.007 263.523L153.934 249.483C153.354 249.595 152.773 249.651 152.14 249.651C145.044 249.595 138.422 243.884 137.33 236.808C136.295 229.785 141.216 224.019 148.314 224.019C153.232 224.019 157.873 226.818 160.633 230.86H151.152L152.878 242.377H177.362L177.427 240.52C177.463 239.322 177.332 238.062 177.145 236.808ZM207.525 211.989L219.443 291H117.841L100 172.488H125.478L121.833 148.043H147.448L119.257 130.75L114.673 100H216.275L233 211.989H207.525Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_359",
    x: 0,
    y: 0,
    width: 333,
    height: 391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_0_359"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmCoreLogoGlow);
export default __webpack_public_path__ + "static/media/hmCoreLogoGlow.28c4d9c1b2fb4f56dd0dab959ad5476a.svg";
export { ForwardRef as ReactComponent };